import {AfterViewInit, Component, ElementRef, OnInit, Renderer2} from '@angular/core';
import {CommonService} from "../../common.service";
import {ApiService} from '../../api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AppChartsService} from '../../app-charts/app-charts.service';
import {CampLeadershipReportService} from './camp-leadership-report.service';
import {fromEvent} from 'rxjs/observable/fromEvent';
import {PlatformLocation} from '@angular/common';

@Component({
  selector: 'app-camp-leadership-report',
  templateUrl: './camp-leadership-report.component.html',
  styleUrls: ['./camp-leadership-report.component.css']
})
export class CampLeadershipReportComponent implements OnInit , AfterViewInit{

  appChartsService: AppChartsService;
  CampLeadershipReportService: CampLeadershipReportService;
  learningMetaId: number; //能力Id
  surveyStatus: number; //前后测类型： 1：前测  2：后测
  chartsType: string = "radar"; //图表类型
  theme: string="survey"; //主题
  staticDoc: any; //静态文案
  report: any;//报告
  pageTitle: string; //  页面标题
  level: any; //能力等级
  levelDesc: string; //能力等级说明
  suggest: string; //学习建议
  contrast: string = "Good"; //对比结果
  contrastSpeech: string; //对比话术
  contrastDesc:string; //对比总结
  a_advantagesKas: any; //存在表现好的KA分析
  a_shortBoardsKas: any; //待提高的KA分析
  shortBoardsFixedSpeech:any; //仅有待提高KA固定话术
  advantagesFixedSpeech: any; //仅存在表现好的KA固定话术
  fixedSpeech: any; //即不存在表现好的KA也不存在待提高的KA固定话术
  developmentTipsKas: any; //发展建议
  developmentTipsFixedSpeech: any; //发展建议固定话术
  teacherName: string; //导师名字
  advantages: any;//优势
  learningPath: any; //学习路径
  learningPathId: number; //学习路径ID
  courseId: number; //课程ID
  courseName: string;//课程名称
  learningTips: any; //学习建议
  developmentTips: string; //发展建议
  chartKAsData: any = []; //图表数据
  assetsRoute: string = "../../assets";
  returnTxt: string = "";
  currentIndex: number = 0;
	//滑动对象
	hammertime:any;
  showInfo: boolean = true;
  isOpenClass:number = 0;
  isSlide: boolean = false;
  timer: any;
  isFirstInPreOrPostTestReport: boolean = false; //是否第一次进入报告
  isScrollBottom: boolean = false; //是否滚到底部
  isShowApproachModule: boolean = false; //是否显示趋近
  subscribeScoll: any;
  isShowShare: boolean = false; //是否跳转分享功能
  approachLoading: boolean = false;
  approachTheme: any = {};
  isPC: boolean = false;
  showPCBtn: boolean = false;
  learningTour: any;
  isShowBack: boolean = false;
  isOnlyLearningPathCannotBack:boolean = false;
  isCustomLock: boolean = false; //用户有没有强制锁定
  projectId: string;
  lock: boolean = false;
  isShowToast: boolean = false;
  promptText: string;
  buttonTheme : any;
  constructor(
    private router: Router,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private el: ElementRef,
    private render: Renderer2,
    private commonService: CommonService,
    private platformLocation: PlatformLocation
  ) { }

  ngOnInit() {
    this.projectId = localStorage.getItem("projectId")
    let projectmsg = JSON.parse(localStorage.getItem('projectmsg'))
    if(this.projectId && projectmsg){
      projectmsg.map(item=>{
        if(item.type == 2 && item.lockType == 1){
          this.lock = item.lock;
          this.promptText = `课程学习将于${item.promptTime}开放。`
        }
      })

    }
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.isOpenClass = Number(localStorage.getItem('openClass'))?1:0;
    this.isPC = !!localStorage.getItem('isPC');
    this.isShowBack = this.platformLocation['location']['href'].indexOf('isShowBack') !== -1;
    this.isOnlyLearningPathCannotBack = !!localStorage.getItem('isOnlyLearningPathCannotBack');
    this.showPCBtn = this.isPC;
    this.appChartsService = new AppChartsService();
    this.CampLeadershipReportService = new CampLeadershipReportService(this.apiService);
     this.getApiData();
     if(this.surveyStatus == 1){
      this.buttonTheme = {
        'position':'inherit',
        'fontSize': 'fontSize15',
        'buttonElem':[
          {
            'color': 'blue',
            'text': '完成学前检测',
            'className': 'inlineBlockRadiusBtn width-100 margin-auto'
          }
        ]
      }
     }else if(this.surveyStatus == 2){
      this.buttonTheme = {
        'position':'inherit',
        'fontSize': 'fontSize15',
        'buttonElem':[
          {
            'color': 'blue',
            'text': '完成阶段考核',
            'className': 'inlineBlockRadiusBtn width-100 margin-auto'
          }
        ]
      }
     }
  }


  ngAfterViewInit(){
    $('body').addClass('heightAuto');
    let audioEle = this.el.nativeElement.querySelector('#audioPlay');
    this.commonService.initPage();
    this.timer = setTimeout(()=>{
      this.isSlide = false;
      this.showInfo = false;
      audioEle && this.render.addClass(audioEle, 'displayNone');
    },5000);


		let that = this;
		if(!that.isPC){
      setTimeout(()=>{
        this.hammertime = new Hammer(document.getElementById('swipeContainer'));
        this.hammertime.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
        this.hammertime.on('swipeup swipedown', function(ev){
          that.logEventType(ev,that);
        });
      },500);
    }
  }

  goNext(){
    $('#swipeContainer').css({
      'top': '-100%',
      'opacity':'0'
    });

    setTimeout(()=>{
      $(".abilityReport").css({'opacity':'1'});
      $('#swipeContainer').hide();
      this.slideBtn();
    },300);
  }

  logEventType(ev,that){
    if(ev.type == "swipeup"){
      $('#swipeContainer').css({
        'top': '-100%',
        'opacity':'0'
      })

      that.hammertime.get('swipe').set({  enable: false  });

      setTimeout(()=>{
      	$(".abilityReport").css({'opacity':'1'});
      	$('#swipeContainer').hide();
      	this.slideBtn();
      },300);
    }
  }

  //根据type获取数据
  getApiData(){
    this.route.params.subscribe(params => {
      this.learningMetaId = params['learningPathId'];
      this.surveyStatus = params['typeId'];
      this.staticDoc = this.CampLeadershipReportService.getStaticDoc(this.surveyStatus );
      this.CampLeadershipReportService.getUserIsFirstInPreOrPostTestReport(this.learningMetaId, this.surveyStatus).then(result=>{
        this.isFirstInPreOrPostTestReport = Number(result.data) === 0 ? true : false;
        this.approachTheme.isFirst = this.isFirstInPreOrPostTestReport
        if(this.isFirstInPreOrPostTestReport){
          this.CampLeadershipReportService.saveUserFirstInPreOrPostTestReport(this.learningMetaId, this.surveyStatus).then();
        }
      }).then(()=>{
        this.getReport(Number(this.surveyStatus));
      })
    });
  }

  //获取报告
  getReport(surveyStatus){
    if(surveyStatus == 1){
      localStorage.setItem('moduleId','1');
      this.pageTitle =  "学前检测报告";
      this.CampLeadershipReportService.getPreTestReport(this.learningMetaId).then(result=>{
        this.report = result;
        this.learningPathId = this.report.learningPathId;
        this.courseId = this.report.courseId;
        this.level = this.report.level ? this.report.level : 1;
        this.levelDesc = this.report.levelDesc;
        this.courseName = this.report.courseName;
        this.teacherName = this.CampLeadershipReportService.getTeacherName( this.courseName );
        this.setLineChartsData(this.level);
        this.suggest = this.report.b_suggest;
        this.learningTips = this.report.learningTips;
        this.chartKAsData = this.report.kas ? [this.report.kas] : [[{"kaName":"KA1","kaScore":10},{"kaName":"KA2","kaScore":10},{"kaName":"KA3","kaScore":10},{"kaName":"KA4","kaScore":10},{"kaName":"KA5","kaScore":10}]];
      }).then(()=>{
        return this.getProgress(this.learningMetaId).then(result=>{
          return this.currentIndex = result[0]['progressList'][0]['currentItemIndex'] == 4 && result[0]['progressList'][0]['progress'] == 100 ? 5 : result[0]['progressList'][0]['currentItemIndex'] ;
        });
      }).then(()=>{
        this.approachTheme.colorSystem = 'dark';
        this.approachTheme.label = ['能力诊断','课程学习','情景模拟','能力考核'];
        this.approachTheme.currentIndex = this.currentIndex-2;
        this.approachTheme.desc = '知道了自己的能力画像，是否希望更上层楼？';
        this.approachTheme.btnTxt = '开启课程学习';
      }).then(()=>{
        this.approachLoading = true;
        //增加学习断点
        this.commonService.addUserBreakPoint({'learningPathMetasId':Number(this.learningMetaId),'moduleId':1,'breakpointUrl':this.platformLocation['location']['href'],'projectId':localStorage.getItem("projectId")?localStorage.getItem("projectId") : null}).then();
      });
    }else if(surveyStatus == 2){
       this.route.queryParams.subscribe(queryParams => {
        this.learningPathId = queryParams['learningPathId'];
        this.courseId = queryParams['courseId'];
       })
      localStorage.setItem('moduleId','4');
      this.pageTitle =  "阶段考核报告";
      this.CampLeadershipReportService.getPostTestReport(this.learningMetaId).then(result=>{
        this.report = result;
        this.courseName = this.report.courseName;
        // this.returnTxt = {1:"返回公开课",2:"返回体验课"}[Number(localStorage.getItem('companiesType'))]||"完成"+this.courseName;
        this.contrastSpeech  = this.report.contrastSpeech;
        this.contrastDesc = this.report.contrastDesc;
        this.teacherName = this.CampLeadershipReportService.getTeacherName( this.courseName );
        this.level = this.report.b_level && this.report.a_level? [this.report.b_level, this.report.a_level] : [1,1];
        this.setLineChartsData(this.level);
        this.a_advantagesKas = this.report.a_advantagesKas;
        this.a_shortBoardsKas  = this.report.a_shortBoardsKas;
        this.shortBoardsFixedSpeech = this.report.shortBoardsFixedSpeech;
        this.advantagesFixedSpeech = this.report.advantagesFixedSpeech;
        this.fixedSpeech = this.report.fixedSpeech;
        this.developmentTipsKas = this.report.newDevelopmentTipsKas;
        this.developmentTipsFixedSpeech = this.report.developmentTipsFixedSpeech;
        this.chartKAsData = this.report.b_kas && this.report.a_kas ? [this.report.b_kas, this.report.a_kas]: [[{"kaName":"KA1","kaScore":10},{"kaName":"KA2","kaScore":10},{"kaName":"KA3","kaScore":10},{"kaName":"KA4","kaScore":10},{"kaName":"KA5","kaScore":10}],[{"kaName":"KA1","kaScore":20},{"kaName":"KA2","kaScore":20},{"kaName":"KA3","kaScore":20},{"kaName":"KA4","kaScore":20},{"kaName":"KA5","kaScore":20}]];
      }).then(()=>{
        this.approachTheme.colorSystem = 'dark';
        this.approachTheme.label = ['能力诊断','课程学习','情景模拟','能力考核'];
        // this.approachTheme.currentIndex = 3;
        this.approachTheme.currentIndex = this.currentIndex - 2;
        this.approachTheme.desc = '';
        this.approachTheme.btnTxt = "完成"+this.courseName;
        this.approachLoading = true;
        //增加学习断点
        this.commonService.addUserBreakPoint({'learningPathMetasId':Number(this.learningMetaId),'moduleId':4,'breakpointUrl':this.platformLocation['location']['href'],'projectId':localStorage.getItem("projectId")?localStorage.getItem("projectId") : null}).then();
      });
    }
  }

  //获取learningTour
  getLearningTour(){
    return this.apiService.ajax({
      'type': 'get',
      'url': '/sr/v2/learningtournew'
    }).toPromise();
  }


  //获取进度
  getProgress(learningPathMetaId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/learning/progress?learningPathMetaIds='+String(learningPathMetaId),
    }).toPromise();
  }


  // 设置LineCharts（等级对象）
  setLineChartsData(level){
    if(typeof (level) === "number"){
      let querySelector = this.el.nativeElement.querySelector('#lv'+level);
      this.render.addClass(querySelector, "post");

    }else if(typeof (level) === "object" && level.constructor === Array){
      let classNames = ['pre', 'post'], domFirstName = ".lv";
      for(let i = 0, len =level.length; i<len; i+=1){
        if(level[i] === level[i+1]){
          classNames = ['eqPre', 'eqPost'];
          this.contrast = "Normal";
        }else if(level[i] < level[i+1]){
          this.contrast = "Good";
          domFirstName = "#lv";
        }else if(level[i] > level[i+1]){
          classNames = ['pre', 'post'];
          this.contrast = "Bad";
        }
        this.render.addClass(this.el.nativeElement.querySelector(domFirstName + level[i]), classNames[i]);
      }

    }
  }

  // 音频收缩
  slideBtn(){
    console.log(this.timer);
    let audioEle = this.el.nativeElement.querySelector('#audioPlay');
    if(this.isSlide){
      this.showInfo = false;
      this.isSlide = false;

      audioEle && this.render.addClass(audioEle, 'displayNone');

      clearTimeout(this.timer);
    }else {
      this.showInfo = true;
      this.isSlide = true;
      audioEle && this.render.removeClass(audioEle, 'displayNone');
      this.timer = setTimeout(() => {
        this.isSlide = false;
        this.showInfo = false;
        audioEle && this.render.addClass(audioEle, 'displayNone');
      }, 5000);
    }
  }

  showToast(){
    this.isShowToast = true;
    setTimeout(()=>{
      this.isShowToast = false;
    },2000);
  }

  // 完成课程
  finishCourse(){
    this.commonService.addUserBreakPoint({'learningPathMetasId':Number(this.learningMetaId),'moduleId':-1,'breakpointUrl':null,'projectId':localStorage.getItem("projectId")?localStorage.getItem("projectId") : null}).then();
    this.commonService.getOnceIno(this.commonService.getOnceValue(this.learningMetaId,10)).then(result=>{
      const projectId = localStorage.getItem("projectId")
      if(this.learningMetaId == 30){
        if(projectId){
          this.router.navigate(['learning-project',projectId]);
          return
        }
        this.router.navigate(['learning-map']);
      }else{
        if(result === 1){
          if(localStorage.getItem('skuId') && !localStorage.getItem('onlyCamp')){
            this.router.navigate(['learning-camp',localStorage.getItem('skuId'),localStorage.getItem('campId')]);
          }else if(localStorage.getItem('skuId') && localStorage.getItem('onlyCamp')){
            this.router.navigate(['learning-camp',localStorage.getItem('skuId'),localStorage.getItem('campId'),-1]);
          }else if(!localStorage.getItem('skuId')){
            if(projectId){
              this.router.navigate(['learning-project',projectId]);
              return
            }
            this.router.navigate(['learning-map']);
          }
        }else{
          this.router.navigate(['share', this.learningMetaId]);
        }
      }
      // let link = this.learningMetaId == 30 ? ['learning-map'] : result === 1 ? ['learning-map'] : ['share', this.learningMetaId];
      $('body').removeClass('heightAuto');
      // this.router.navigate(link);
      this.commonService.setOnceIno(this.commonService.getOnceValue(this.learningMetaId,10)).subscribe()
    });
  }

  // 关闭
  close() {
    $('body').removeClass('heightAuto');
    // if(this.projectId && this.projectId.trim() != ''){
    //   localStorage.removeItem("projectmsg")
    //   let link = ['learning-project-path', this.learningMetaId];
    //   this.router.navigate(link,{
		// 		queryParams:{
		// 			projectId: this.projectId
		// 		}
		// 	});
    // }else{
      const learningPathMetaId = localStorage.getItem("learningPathMetaId");
      let link = ['learning-path',learningPathMetaId];
      this.router.navigate(link);
    // }

  }

}



// WEBPACK FOOTER //
// ./src/app/learning-camp/camp-leadership-report/camp-leadership-report.component.ts